import src from "IMAGE";
export default { src, width: 241, height: 67, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAAAAHAAAABtAAAAagAAAG8AAABlAAAAaAAAAGgAAABaAFQDA3BYBANlUiICcWM1AINVGgBcNwwIZAQ2DWEANAlWCrEJi/35LZUAAAAASUVORK5CYII="};
